import { Injectable } from '@angular/core'

import { Observable } from 'rxjs/Observable'

import { LectureApiBase } from './lecture-api'
import { SharingGroup } from '../models'

@Injectable()
export class SharingGroupApi {
  apiPath(videoId: number, groupId = '') {
    return `videos/${videoId}/groups/${groupId}`
  }

  constructor(
    private api: LectureApiBase,
  ) { }

  index(videoId: number): Observable<SharingGroup[]> {
    return this.api.listWithObject(SharingGroup, this.apiPath(videoId))
  }

  create(videoId: number, name: string): Observable<SharingGroup> {
    return this.api.postWithObject(SharingGroup, this.apiPath(videoId), { sharingGroup: { name } })
  }

  update(videoId: number, groupId: number, name: string): Observable<SharingGroup> {
    return this.api.putWithObject(SharingGroup, this.apiPath(videoId, groupId.toString()), { sharingGroup: { name } })
  }

  destroy(videoId: number, groupId: number): Observable<any> {
    return this.api.delete(this.apiPath(videoId, groupId.toString()))
  }

  join(videoId: number, groupId: number, userId: number = null): Observable<SharingGroup> {
    return this.api.postWithObject(SharingGroup, `${this.apiPath(videoId, groupId.toString())}/join`, { userId })
  }

  leave(videoId: number, groupId: number, userId: number = null): Observable<SharingGroup> {
    return this.api.delete(this.api.makeUrlWithParams(`${this.apiPath(videoId, groupId.toString())}/leave`, { userId }))
  }

  myGroup(videoId: number): Observable<SharingGroup> {
    return this.api.getWithObject(SharingGroup, this.apiPath(videoId, 'my_group'))
  }
}



// WEBPACK FOOTER //
// ./src/apis/sharing-group.ts